<template>
  <div id="Geocode">
    <el-row>
      <el-col>
        <Title
          title="Geocodificar"
          subtitle="Edita las direcciones no encontradas"/>
      </el-col>
    </el-row>
    <el-row v-if="!socsMode"
            :type="'flex'"
            :gutter="10"
            class="top-container">
      <el-col :span=5>
        <el-date-picker
          class="datePicker"
          v-model="selectedDate"
          format="dd-MM-yyyy"
          placeholder="Fecha"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-col>
      <el-col :span=5>
        <BaseSelectRegion
          @sendRegion="setRegion"
          :regionId="selectedRegionId">
        </BaseSelectRegion>
      </el-col>
      <el-col :span=5>
        <BaseSelectLocality
          @sendLocality="setLocality"
          :regionId="selectedRegionId">
        </BaseSelectLocality>
      </el-col>
      <el-col :span=1>
        <el-button v-if="!socsMode"
                   class="btn primary"
                   icon="fa fa-search"
                   @click="validateForm">
        </el-button>
      </el-col>
      <el-col :span=5>
        <GeocodeSummary
          :dataDesk="dataDesk">
        </GeocodeSummary>
      </el-col>
    </el-row>
    <el-row v-loading="loading">
      <template v-if="!dataCalled">
        <div class="container-empty">
          <div class="hero">
            <div class="title">Selecciona las opciones para obtener puntos a geocodificar</div>
            <div class="subtitle">
              <p><strong><i>Elige fecha y región, elegir localidad es opcional</i></strong></p>
            </div>
          </div>
        </div>
      </template>
      <template v-if="dataCalled && data.unlocated === 0 && !socsMode">
        <div class="container-empty">
          <div class="hero">
            <div class="title">No se encontraron puntos sin geocodificar.</div>
            <p></p>
            <div class="subtitle">
                <span class="link"
                      style="color: white"
                      @click="$router.push({name: 'planning'})">
                  <strong>PLANIFICA AQUÍ &nbsp;</strong>
                  <i class="fas fa-map"></i>
                </span>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="dataCalled && (data.total_points !== 0 || socsMode) && !loading">
        <el-col :span="24">
          <div class="sideForm">
            <GeocodeAssistV2 :delivery_point="data.delivery_points"
                             :socsMode="socsMode"
                             @updated="updatedSocPoint"
                             @changeAddress="getPoints">
            </GeocodeAssistV2>
          </div>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment';
import Title from '../components/base/Title.vue';
import BaseSelectRegion from '../components/BaseSelectRegion.vue';
import BaseSelectLocality from '../components/BaseSelectLocality.vue';
import GeocodeSummary from '../components/GeocodeSummary.vue';
import GeocodeAssistV2 from '../components/GeocodeAssistV2.vue';
import { apiRequest } from '../../backend/vue-axios/axios';
import {
  getRumDuration,
  startRumTiming,
  trackBusinessFlow,
} from '../../observability/datadogRum';

export default {
  name: 'Geocode',
  components: {
    Title,
    BaseSelectRegion,
    BaseSelectLocality,
    GeocodeSummary,
    GeocodeAssistV2,
  },
  data() {
    return {
      socsMode: false,
      selectedDate: '',
      selectedRegionId: 0,
      selectedLocalityId: '',
      dataDesk: [{
        notFound: {
          title: 'A geocodificar',
          data: 0,
          total: 0,
        },
      }],
      dataCalled: false,
      loading: false,
      data: 0,
      assistData: null,
      mapData: null,
      position: {},
      place: {},
      activeMap: true,
      mode: 1,
      draggableMarker: false,
      points: [],
    };
  },
  methods: {
    setRegion(regionId) {
      this.selectedRegionId = regionId;
    },
    setLocality(localityId) {
      this.selectedLocalityId = localityId;
    },
    updatedSocPoint() {
      if (sessionStorage.getItem('suborders') !== null) {
        localStorage.setItem('geoUpdated', JSON.parse(sessionStorage.getItem('suborders'))[0]);
        window.open('', 'geosortMain');
      }
    },
    getPointBySocs() {
      this.loading = true;
      this.dataCalled = true;
      const startedAt = startRumTiming();
      if (JSON.parse(sessionStorage.getItem('suborders')).length > 0) {
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'suborder_geocoding',
          action: 'load_requested',
          status: 'attempt',
          context: {
            suborders_count: JSON.parse(sessionStorage.getItem('suborders')).length,
            source: 'session_suborders',
          },
        });
        apiRequest({
          module: 'geocoding',
          service: 'suborders_request',
          params: {
            suborders: JSON.parse(sessionStorage.getItem('suborders')),
          },
        }).then((response) => {
          this.data = response.data;
          this.dataDesk[0].notFound.data = this.data.unlocated;
          this.dataDesk[0].notFound.total = this.data.total_points;
          this.loading = false;
          trackBusinessFlow({
            module: 'geocoding',
            flow: 'suborder_geocoding',
            action: 'load_completed',
            status: 'success',
            durationMs: getRumDuration(startedAt),
            context: {
              total_points: this.data.total_points,
              unlocated_points: this.data.unlocated,
              suborders_count: JSON.parse(sessionStorage.getItem('suborders')).length,
            },
          });
        }).catch(() => {
          trackBusinessFlow({
            module: 'geocoding',
            flow: 'suborder_geocoding',
            action: 'load_completed',
            status: 'error',
            durationMs: getRumDuration(startedAt),
          });
          this.$notify.error({
            title: 'Error',
            message: 'Error al obtener puntos',
          });
          this.loading = false;
        });
      }
    },
    validateForm() {
      // eslint-disable-next-line
      if (this.selectedRegionId === 0 || this.selectedRegionId === -1 || this.selectedDate === null) {
        this.$notify.warning({
          title: 'Advertencia',
          message: 'Fecha y región son campos obligatorios',
        });
      } else {
        this.getPoints();
      }
    },
    getPoints() {
      this.loading = true;
      this.dataCalled = true;
      const startedAt = startRumTiming();
      const date = moment(this.selectedDate).toJSON();
      trackBusinessFlow({
        module: 'geocoding',
        flow: 'daily_geocoding',
        action: 'search_requested',
        status: 'attempt',
        context: {
          region_id: this.selectedRegionId,
          has_locality_filter: this.selectedLocalityId !== '',
          locality_scope: this.selectedLocalityId === '' ? 'all' : 'single',
        },
      });
      apiRequest({
        module: 'geocoding',
        service: 'get_unlocated',
        params: {
          region_id: this.selectedRegionId,
          locality_id: this.selectedLocalityId,
          date,
        },
      }).then((response) => {
        this.data = response.data;
        this.dataDesk[0].notFound.data = this.data.unlocated;
        this.dataDesk[0].notFound.total = this.data.total_points;
        this.loading = false;
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'daily_geocoding',
          action: 'search_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            total_points: this.data.total_points,
            unlocated_points: this.data.unlocated,
            region_id: this.selectedRegionId,
            locality_scope: this.selectedLocalityId === '' ? 'all' : 'single',
          },
        });
      }).catch(() => {
        trackBusinessFlow({
          module: 'geocoding',
          flow: 'daily_geocoding',
          action: 'search_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
        });
        this.$notify.error({
          title: 'Error',
          message: 'Error al obtener puntos',
        });
        this.loading = false;
      });
    },
  },
  created() {
    if (this.$route.query.v === 'fromSubs') {
      this.socsMode = true;
      this.getPointBySocs();
    }
  },
  mounted() {
    this.selectedDate = moment().format('YYYY-MM-DD');
  },
};
</script>

<style lang="scss" scoped>
  .desk-container {
    box-sizing: border-box;
    &:nth-child(2) {
      margin-right: 10px;
    }
  }
  .el-button.btn.primary {
    height: 40px;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100% !important;
  }
  .top-container {
    display: flex;
    padding: 0 0 10px;
  }
  .sideForm {
    padding: 0 0 10px 0;
  }
</style>
